import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, tap } from 'rxjs';

import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  // token: string | null;
  private apiUrl = 'https://api.adiem.com.au';
  constructor(
    // private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add auth header with jwt if account is logged in and request is to the api url
    // this.token = this.authService.token;
    // const isLoggedIn = this.authService.checkTokenExpired();
    // const expiry;
    // const isExpired;
    const isApiUrl = request.url.startsWith(this.apiUrl);

    if (isApiUrl) {
      // console.log('Sending headers....');
      request = request.clone({
        setHeaders: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        }
      });

      // console.log('Angular Request Headers: ', request);
    }
    return next.handle(request).pipe(
      tap({
        next: () => { },
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            // If user isn't logged in any more
            if (err.status === 400) {
              // this.authService.logout();
              // this.router.navigate(['login']);
              return;
            }
            // If user's token has expired
            else if (err.status === 401) {
              // this.authService.logout();
              // this.router.navigate(['login']);
              return;
            }
            // Do nothing
            else {
              return;
            }
          }
        }
      })
    );
  }
}
